export default {
  all: {
    id: 'bo_seller_global_select_category_option_all',
    defaultMessage: 'All',
  },
  label: {
    id: 'bo_seller_global_select_category_label',
    defaultMessage: 'Item category',
  },
}
